export default defineNuxtRouteMiddleware(async (to) => {
    const { isDraftModeEnabled } = useDraftMode();
    if (isDraftModeEnabled.value) return;
    if (to.path.startsWith('/api/') || to.path.startsWith('/_nuxt/') || to.path.startsWith('/__webpack_hmr')) return;
    if (to.meta.skipStoryblokLockCheck) return;

    const { rawPath } = useCleanStoryblokPath(to);
    const { data: story, error } = await useStory<PageComponentStoryblok>(rawPath, null, {
        disableFatalErrors: true,
        route: to
    });
    if (error.value) return;

    const restricted = story.value?.content?.__pageRestricted;
    const target = useStoryblokUrl(story.value?.content?.__redirectTarget);

    if (!restricted || !target) return;

    const external = /^https?:\/\//i.test(target);

    const normalizedTarget = external ? target : `/${target.replace(/^\/+/, '')}`;
    const normalizedCurrent = `/${to.path.replace(/^\/+/, '')}`;

    if (!external && normalizedCurrent === normalizedTarget) {
        console.warn('[redirectLockedPages] prevented self-redirect loop:', normalizedTarget);
        return;
    }

    log.debug(
        `[redirectLockedPages] Redirecting from ${normalizedCurrent} to ${normalizedTarget} (external: ${external})`
    );
    return navigateTo(normalizedTarget, { replace: true, external });
});
